import { combineReducers } from 'redux'

import common from './common'
import eventgroupPage from './eventgroup-page'
import eventgroupDetailsPage from './eventgroup-details-page'
import homePage from './home-page'
import performancePage from './performance-page'
import promoCodePage from './promo-code-page'
import setupformPage from './setupform-page'
import setupformVouchersPage from './setupform-vouchers-page'
import ticketingPage from './ticketing-page'

const pages = combineReducers({
  common,
  eventgroupPage,
  eventgroupDetailsPage,
  homePage,
  performancePage,
  promoCodePage,
  setupformPage,
  setupformVouchersPage,
  ticketingPage,
})

export default pages



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/index.js
 **/